import { Component, input } from '@angular/core';
import { TabsInnerWrapComponent } from '../../components/tabs-inner-wrap/tabs-inner-wrap.component';
import { CallWordsComponent } from './call-words/call-words.component';
import { ReplaceWordsComponent } from './replace-words/replace-words.component';
import { PronounceWordsComponent } from './pronounce-words/pronounce-words.component';
import { SttWordsComponent } from './stt-words/stt-words.component';
import { CleanTranscriptWordsComponent } from './clean-transcript-words/clean-transcript-words.component';
import { CleanTranscriptPromptComponent } from './clean-transcript-prompt/clean-transcript-prompt.component';

@Component({
  selector: 'tab-key-words-details',
  imports: [TabsInnerWrapComponent, CallWordsComponent, ReplaceWordsComponent, PronounceWordsComponent, SttWordsComponent, CleanTranscriptWordsComponent, CleanTranscriptPromptComponent],
  templateUrl: './key-words-details.component.html',
  styleUrl: './key-words-details.component.scss',
})
export class KeyWordsDetailsComponent {
  // Self Authoring handles transcript language separately, so the Clean Transcript prompt is old Sim Builder only
  isSelfAuthoring = input(false);
}
